import { client } from '@trello/graphql';

import { WorkspaceState, WorkspaceStateStatus } from '../workspaceState';

import {
  WorkspaceForBoardDocument,
  WorkspaceForBoardQueryResult,
  WorkspaceForBoardQueryVariables,
} from './WorkspaceForBoard.generated';

export async function getWorkspaceForBoard(
  shortLinkOrId: string,
): Promise<WorkspaceState> {
  const results = await client.query<
    WorkspaceForBoardQueryResult['data'],
    WorkspaceForBoardQueryVariables
  >({
    query: WorkspaceForBoardDocument,
    variables: { shortLinkOrId },
  });
  return {
    status: WorkspaceStateStatus.READY,
    error: null,
    isGlobal: false,
    idWorkspace: results?.data?.board?.idOrganization ?? null,
  };
}
